export default "__VITE_ASSET__jINQhQUa__"